import { CHOOSE_ADD_YES } from '../../../components/Address/addressUtils/addressConstants';

let isAboutBusinessSubmitted = false;
export const setAboutBusinessSubmitted = () => {
  isAboutBusinessSubmitted = true;
};

export const isAboutBusinessFormSubmitted = () => isAboutBusinessSubmitted;

export const getInitialValues = (data) =>
  (data.numberOfPeople &&
    data.needLicence &&
    data.industryType &&
    data.activityTypes &&
    data.industryDescription &&
    checkNeedLicence(data)) ||
  isAboutBusinessFormSubmitted()
    ? data
    : '';

export const getInitialValuesMultiParty = (data) =>
  (data &&
    data.registeredName &&
    data.registeredNumber &&
    data.incorporationDate &&
    getInitialValues(data)) ||
  isAboutBusinessFormSubmitted()
    ? data
    : {};

export const checkNeedLicence = (data) =>
  data.needLicence === CHOOSE_ADD_YES ? data.typeOfLicense : true;
